





import RoleServices from '@/services/role';
import { Vue, Component, ModelSync } from 'vue-property-decorator';
@Component
export default class KRoleInput extends Vue {
  @ModelSync('value', 'change', { type: String })
  roleCode!: string;

  roleSrv = new RoleServices();
  roleList: any[] = [];

  async created() {
    let res = await this.roleSrv.getList();
    res.forEach((v: any) => {
      if (v.roleModule == '0') {
        let label = '决策分析服务-';
        if (v.roleKind == '0') {
          label += v.roleName;
        }
        if (v.roleKind == '1') {
          label += v.roleRefDept + '-' + v.roleName;
        }
        this.roleList.push({ label, value: v.roleCode });
      }
      if (v.roleModule == '1') {
        let label = '财务监管报送-';
        if (v.roleKind == '0') {
          label += v.roleName;
        }
        if (v.roleKind == '1') {
          label += v.roleRefDept + '-' + v.roleName;
        }
        this.roleList.push({ label, value: v.roleCode });
      }
    });
  }
}
